import {Logo181Icon, Logo189Icon, Logo1Icon, Logo347Icon} from 'common/Icons';
import {useTranslation} from 'react-i18next';

function Logo() {
    const {t} = useTranslation();

    const SelectLogo = (brokerCode: number) => {
        if (brokerCode === 189) {
            return <Logo189Icon/>;
        } else if (brokerCode === 1) {
            return <Logo1Icon/>;
        } else if (brokerCode === 347) {
            return <Logo347Icon/>
        } else if (brokerCode === 181) {
            return <Logo181Icon/>
        } else {
            return null;
        }
    };

    return (
        <div className="md:flex justify-center items-center hidden mt-4">
            {SelectLogo(window.api?.BROKER_CODE)}
            <span className="mr-1 text-b2xl lg:text-2xl  font-medium lg:font-medium">
				{t(`BrokerCode_${window.api?.BROKER_CODE}.Title`)}
			</span>
        </div>
    );
}

export default Logo;
